import { render, staticRenderFns } from "./SupplierProfile.vue?vue&type=template&id=6d366295&"
import script from "./SupplierProfile.vue?vue&type=script&lang=js&"
export * from "./SupplierProfile.vue?vue&type=script&lang=js&"
import style0 from "./SupplierProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports